/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* OBSERWOWANE LICZBY — Fala 1 (29.09.2026).
 *
 * Magazyn wspolny dla centrum statystyk, profilu liczby, raportu i wynikow
 * z wyborem „Obserwuj”. Samo zaladowanie nie pobiera pakietu danych.
 *
 *  1. Magazyn `pewniaki:obserwowane-liczby:v1` — osobny od
 *     `pewniaki:moje-zestawy:v2` (gotowe kupony) i od przypiec analiz.
 *     Ksztalt: {v:1, okno:'50', gry:{lotto:[3,17], ...}}. Dane z localStorage
 *     sa niezaufane: zamknieta lista gier i pul, liczby calkowite, bez
 *     duplikatow, najwyzej 20 na gre. Kazdy zapis czyta biezacy stan tuz
 *     przed zmiana (druga karta mogla go zmienic) i sprawdza, czy sie udal.
 *  2. Panel — dane z jednego pakietu gry analizy/obserwowane.json (generator
 *     bin/lib-profil-obserwowane.php), pobieranego dopiero, gdy lista nie jest
 *     pusta; raz na widok. Wszystkie kolumny z jednego zakresu jednej wersji.
 *  3. Przycisk na profilu — ta sama lista.
 *
 * Lista nie trafia do adresu ani do analityki. Tekst wstawiany przez
 * textContent — nic z localStorage nie idzie do innerHTML. */
/* Fala 3 (30.09.2026), w tym samym pliku:
 *  4. Preferencje miar panelu `pewniaki:obserwowane-panel:v1` — ktore kolumny
 *     (wystapienia, przerwa, ostatnie) i czy partnerzy w rozwinieciu, w jakiej
 *     kolejnosci; osobno dla gry. Domyslnie widok Fali 1.
 *  5. Punkty odniesienia `pewniaki:obserwowane-obejrzane:v1` — dla gry i
 *     zakresu N: trwaly numer i odcisk ostatniego OBEJRZANEGO losowania oraz
 *     licznik/przerwa kazdej obserwowanej liczby wtedy. Zmiany od poprzedniego
 *     obejrzenia licza sie z dziennika analizy/obserwowane-dziennik.json
 *     (generator lib-profil-obserwowane.php): nowe losowania = wpisy za
 *     zapamietanym numerem (ten sam odcisk = historia bez korekt), nowe
 *     wystapienia liczone wprost z tych losowan, wypadle z okna =
 *     licznik_wtedy + nowe − licznik_teraz. Widok jest „obejrzany" dopiero po
 *     udanym renderze, gdy tabela jest w widocznej karcie i na ekranie
 *     (IntersectionObserver + visibilityState); sam fetch, ukryta karta i panel
 *     poza ekranem nie przesuwaja punktu. Porownanie policzone raz na zakres
 *     zostaje stabilne przez cala wizyte; starsza karta nie nadpisuje nowszego
 *     punktu (porownanie daty konca). Zdarzenie DOM `pewniaki:obserwowane-zmiana`
 *     po kazdej udanej zmianie listy/preferencji (skrot na glownej, kopia).
 *  6. Operacje zbiorcze dla kopii/importu (obserwowane-kopia.js):
 *     zastap(gry, okno), wyczyscWszystko(), preferencje.zastap/reset,
 *     obejrzane.wyczysc — kazda czyta swiezy stan i sprawdza zapis. */
(function (root, doc) {
    'use strict';

    var KLUCZ = 'pewniaki:obserwowane-liczby:v1';
    var KLUCZ_PREF = 'pewniaki:obserwowane-panel:v1';
    var KLUCZ_OBEJRZANE = 'pewniaki:obserwowane-obejrzane:v1';
    var ZDARZENIE = 'pewniaki:obserwowane-zmiana';
    var MIARY = ['h', 'g', 'l', 'p'];
    var LIMIT = 20;
    var PULE = { 'lotto': 49, 'lotto-plus': 49, 'mini-lotto': 42, 'multi-multi': 80, 'eurojackpot': 50, 'kaskada': 24 };
    var OKNA = ['7', '14', '25', '50', '100', '250', '500'];
    var OKNA_PAKIET = ['25', '50', '100', '250', '500'];
    function poprawneOkno(v) {
        var s = String(v === undefined || v === null ? '' : v);
        return /^[1-9][0-9]{0,2}$/.test(s) && Number(s) >= 7 && Number(s) <= 500;
    }

    /* ------------------------------------------------------------ teksty --- */
    var T = {};
    var zrodloTekstow = doc.querySelector('[data-obs-teksty]');
    if (zrodloTekstow) {
        try { T = JSON.parse(zrodloTekstow.textContent) || {}; } catch (e) { T = {}; }
    }
    function t(klucz, parametry) {
        var s = typeof T[klucz] === 'string' ? T[klucz] : klucz;
        return s.replace(/\$\{([A-Za-z_]+)\}/g, function (m, nazwa) {
            return parametry && Object.prototype.hasOwnProperty.call(parametry, nazwa) ? String(parametry[nazwa]) : m;
        });
    }
    var en = (doc.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    function liczbaTxt(n) { return Number(n).toLocaleString(jst("obserwowane_liczby_js.d8e455187026")); }
    // Odmiana: _1 (1), _2 (2–4, 22–24…, bez 12–14), _5 (reszta). EN: _1 i _5.
    function odmiana(n) {
        if (n === 1) { return '_1'; }
        if (en) { return '_5'; }
        var j = n % 10, d = n % 100;
        return j >= 2 && j <= 4 && (d < 12 || d > 14) ? '_2' : '_5';
    }

    // Daty jak w profilu (Twig |date('d.m.Y H:i') przy strefie Europe/Warsaw).
    var fmt = null, fmtReady = false;
    function data(iso) {
        var d = new Date(iso);
        if (!iso || isNaN(d.getTime())) { return '—'; }
        // Pusty panel i strony bez dat nie potrzebuja inicjalizacji Intl.
        if (!fmtReady) {
            fmtReady = true;
            try {
                fmt = new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
            } catch (e) { fmt = null; }
        }
        if (fmt && fmt.formatToParts) {
            var cz = {};
            fmt.formatToParts(d).forEach(function (p) { cz[p.type] = p.value; });
            return cz.day + '.' + cz.month + '.' + cz.year + ' ' + (cz.hour === '24' ? '00' : cz.hour) + ':' + cz.minute;
        }
        return d.toISOString().slice(0, 16).replace('T', ' ');
    }

    /* ----------------------------------------------------------- magazyn --- */
    function pusty() { return { v: 1, okno: '50', gry: {} }; }

    function oczysc(d) {
        var s = pusty(), uszkodzony = false;
        if (!d || typeof d !== 'object' || Array.isArray(d) || d.v !== 1) { return { stan: s, uszkodzony: true }; }
        if (poprawneOkno(d.okno)) { s.okno = String(d.okno); }
        var gry = d.gry && typeof d.gry === 'object' && !Array.isArray(d.gry) ? d.gry : {};
        Object.keys(gry).forEach(function (gra) {
            if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !Array.isArray(gry[gra])) { uszkodzony = true; return; }
            var out = [];
            gry[gra].forEach(function (x) {
                if (typeof x === 'number' && isFinite(x) && Math.floor(x) === x && x >= 1 && x <= PULE[gra] && out.indexOf(x) < 0 && out.length < LIMIT) {
                    out.push(x);
                } else { uszkodzony = true; }
            });
            out.sort(function (a, b) { return a - b; });
            if (out.length) { s.gry[gra] = out; }
        });
        return { stan: s, uszkodzony: uszkodzony };
    }

    /** {stan, dostepny, uszkodzony} — nie zapisuje nic przy odczycie. */
    function wczytaj() {
        var surowe;
        try { surowe = root.localStorage.getItem(KLUCZ); }
        catch (e) { return { stan: pusty(), dostepny: false, uszkodzony: false }; }
        if (surowe === null) { return { stan: pusty(), dostepny: true, uszkodzony: false }; }
        try {
            var w = oczysc(JSON.parse(surowe));
            return { stan: w.stan, dostepny: true, uszkodzony: w.uszkodzony };
        } catch (e) {
            return { stan: pusty(), dostepny: true, uszkodzony: true };
        }
    }

    function zapisz(stan) {
        var tekst = JSON.stringify(stan);
        try {
            root.localStorage.setItem(KLUCZ, tekst);
            return root.localStorage.getItem(KLUCZ) === tekst;
        } catch (e) { return false; }
    }

    /** Odczyt biezacego stanu -> zmiana -> zapis z kontrola. */
    function zmien(fn) {
        var w = wczytaj();
        if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
        var s = w.stan;
        var r = fn(s);
        if (r && r.ok === false) { return r; }
        if (!zapisz(s)) { return { ok: false, powod: 'zapis' }; }
        return { ok: true, stan: s };
    }

    function poprawna(gra, n) {
        return Object.prototype.hasOwnProperty.call(PULE, gra) && typeof n === 'number' && Math.floor(n) === n && n >= 1 && n <= PULE[gra];
    }
    function oglos(rodzaj, gra) {
        if (typeof root.CustomEvent !== 'function') { return; }
        try { doc.dispatchEvent(new root.CustomEvent(ZDARZENIE, { detail: { rodzaj: rodzaj, gra: gra || null } })); } catch (e) { /* stary silnik */ }
    }
    /** Wspolny odczyt/zapis malego klucza JSON z kontrola zapisu (preferencje, punkty odniesienia). */
    function odczytKlucza(klucz) {
        var surowe;
        try { surowe = root.localStorage.getItem(klucz); }
        catch (e) { return { dane: null, dostepny: false, uszkodzony: false }; }
        if (surowe === null) { return { dane: null, dostepny: true, uszkodzony: false }; }
        try { var d = JSON.parse(surowe); return { dane: d && typeof d === 'object' && !Array.isArray(d) ? d : null, dostepny: true, uszkodzony: !(d && typeof d === 'object' && !Array.isArray(d)) }; }
        catch (e) { return { dane: null, dostepny: true, uszkodzony: true }; }
    }
    function zapisKlucza(klucz, dane) {
        var tekst = JSON.stringify(dane);
        try { root.localStorage.setItem(klucz, tekst); return root.localStorage.getItem(klucz) === tekst; }
        catch (e) { return false; }
    }
    function usunKlucz(klucz) {
        try { root.localStorage.removeItem(klucz); return root.localStorage.getItem(klucz) === null; }
        catch (e) { return false; }
    }
    function calkowitaN(x, max) { return typeof x === 'number' && isFinite(x) && Math.floor(x) === x && x >= 1 && x <= max; }

    /* ----------------------------------------- preferencje miar (Fala 3) --- */
    function oczyscMiary(lista) {
        if (!Array.isArray(lista)) { return null; }
        var out = [];
        for (var i = 0; i < lista.length; i++) {
            if (MIARY.indexOf(lista[i]) < 0 || out.indexOf(lista[i]) >= 0) { return null; }
            out.push(lista[i]);
        }
        return out;
    }
    function oczyscPreferencje(d) {
        var s = { v: 1, gry: {} }, uszkodzony = false;
        if (!d || d.v !== 1) { return { stan: s, uszkodzony: true }; }
        var gry = d.gry && typeof d.gry === 'object' && !Array.isArray(d.gry) ? d.gry : {};
        Object.keys(gry).forEach(function (gra) {
            if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !gry[gra] || typeof gry[gra] !== 'object') { uszkodzony = true; return; }
            var m = oczyscMiary(gry[gra].miary);
            if (m === null) { uszkodzony = true; return; }
            s.gry[gra] = { miary: m };
        });
        return { stan: s, uszkodzony: uszkodzony };
    }
    var Preferencje = {
        klucz: KLUCZ_PREF,
        miary: MIARY.slice(),
        domyslne: function () { return MIARY.slice(); },
        /** {miary, wlasne, dostepny, uszkodzony} — nic nie zapisuje. */
        wczytaj: function (gra) {
            var w = odczytKlucza(KLUCZ_PREF);
            if (w.dane === null) { return { miary: MIARY.slice(), wlasne: false, dostepny: w.dostepny, uszkodzony: w.uszkodzony }; }
            var o = oczyscPreferencje(w.dane);
            var g = o.stan.gry[gra];
            return { miary: g ? g.miary.slice() : MIARY.slice(), wlasne: !!g, dostepny: true, uszkodzony: o.uszkodzony };
        },
        wszystkie: function () { var w = odczytKlucza(KLUCZ_PREF); return w.dane === null ? { v: 1, gry: {} } : oczyscPreferencje(w.dane).stan; },
        zapisz: function (gra, miary) {
            if (!Object.prototype.hasOwnProperty.call(PULE, gra)) { return { ok: false, powod: 'gra' }; }
            var m = oczyscMiary(miary);
            if (m === null) { return { ok: false, powod: 'miary' }; }
            var w = odczytKlucza(KLUCZ_PREF);
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            var s = w.dane === null ? { v: 1, gry: {} } : oczyscPreferencje(w.dane).stan;
            s.gry[gra] = { miary: m };
            if (!zapisKlucza(KLUCZ_PREF, s)) { return { ok: false, powod: 'zapis' }; }
            oglos('preferencje', gra);
            return { ok: true, miary: m };
        },
        /** Import: caly slownik gier naraz (zwalidowany), albo odrzucenie bez zapisu. */
        zastap: function (gry) {
            if (!gry || typeof gry !== 'object' || Array.isArray(gry)) { return { ok: false, powod: 'format' }; }
            var s = { v: 1, gry: {} }, klucze = Object.keys(gry);
            for (var i = 0; i < klucze.length; i++) {
                var gra = klucze[i];
                if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !gry[gra] || typeof gry[gra] !== 'object') { return { ok: false, powod: 'format' }; }
                var m = oczyscMiary(gry[gra].miary);
                if (m === null) { return { ok: false, powod: 'format' }; }
                s.gry[gra] = { miary: m };
            }
            var w = odczytKlucza(KLUCZ_PREF);
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            if (!zapisKlucza(KLUCZ_PREF, s)) { return { ok: false, powod: 'zapis' }; }
            oglos('preferencje', null);
            return { ok: true };
        },
        /** „Przywroc ustawienia panelu": tylko ten klucz. */
        reset: function () {
            var w = odczytKlucza(KLUCZ_PREF);
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            if (!usunKlucz(KLUCZ_PREF)) { return { ok: false, powod: 'zapis' }; }
            oglos('preferencje', null);
            return { ok: true };
        }
    };

    /* ------------------------------ punkty odniesienia „obejrzano" (Fala 3) --- */
    function oczyscObejrzane(d) {
        var s = { v: 1, gry: {} };
        if (!d || d.v !== 1 || !d.gry || typeof d.gry !== 'object' || Array.isArray(d.gry)) { return s; }
        Object.keys(d.gry).forEach(function (gra) {
            if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !d.gry[gra] || typeof d.gry[gra] !== 'object') { return; }
            var okna = {};
            Object.keys(d.gry[gra]).slice(0, 64).forEach(function (okno) {
                if (!poprawneOkno(okno)) { return; }
                var p = d.gry[gra][okno];
                if (!p || typeof p !== 'object' || (p.id !== null && !calkowitaN(p.id, 1e12)) || typeof p.t !== 'string' || !isFinite(Date.parse(p.t)) || typeof p.o !== 'string' || !/^[0-9a-f]{16}$/.test(p.o) || !p.liczby || typeof p.liczby !== 'object') { return; }
                var liczby = {};
                Object.keys(p.liczby).forEach(function (k) {
                    var n = Number(k), w = p.liczby[k];
                    if (!calkowitaN(n, PULE[gra]) || !w || typeof w !== 'object' || !(typeof w.h === 'number' && w.h >= 0 && Math.floor(w.h) === w.h) || !(w.g === null || (typeof w.g === 'number' && w.g >= 0 && Math.floor(w.g) === w.g))) { return; }
                    liczby[n] = { h: w.h, g: w.g };
                });
                okna[okno] = { id: p.id, t: p.t, o: p.o, liczby: liczby };
            });
            if (Object.keys(okna).length) { s.gry[gra] = okna; }
        });
        return s;
    }
    function stanObejrzane() { var w = odczytKlucza(KLUCZ_OBEJRZANE); return { stan: w.dane === null ? { v: 1, gry: {} } : oczyscObejrzane(w.dane), dostepny: w.dostepny }; }
    var Obejrzane = {
        klucz: KLUCZ_OBEJRZANE,
        wczytaj: function (gra, okno) { var s = stanObejrzane().stan; return s.gry[gra] && s.gry[gra][okno] ? s.gry[gra][okno] : null; },
        /**
         * Zapis punktu {id, t, o, liczby:{n:{h,g}}} dla gry i zakresu. Nie cofa nowszego
         * punktu (starsza karta z danymi sprzed aktualizacji); ten sam koniec = dopisuje
         * brakujace liczby (nowe obserwacje), nie zmienia istniejacych wpisow.
         */
        zapisz: function (gra, okno, punkt) {
            if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !poprawneOkno(okno) || !punkt) { return { ok: false, powod: 'gra' }; }
            var w = stanObejrzane();
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            var s = w.stan, gry = s.gry[gra] || {}, obecny = gry[okno] || null;
            if (obecny && Date.parse(obecny.t) > Date.parse(punkt.t)) { return { ok: true, pominieto: 'nowszy' }; }
            if (obecny && obecny.id === punkt.id && obecny.o === punkt.o) {
                var zmiana = false;
                Object.keys(punkt.liczby).forEach(function (n) { if (!obecny.liczby[n]) { obecny.liczby[n] = punkt.liczby[n]; zmiana = true; } });
                if (!zmiana) { return { ok: true, pominieto: 'bez_zmian' }; }
            } else {
                gry[okno] = { id: punkt.id, t: punkt.t, o: punkt.o, liczby: punkt.liczby };
            }
            s.gry[gra] = gry;
            if (!zapisKlucza(KLUCZ_OBEJRZANE, s)) { return { ok: false, powod: 'zapis' }; }
            return { ok: true };
        },
        /** Usunieta obserwacja nie zostawia punktu odniesienia (nowa liczba nie dziedziczy). */
        usunLiczbe: function (gra, n) {
            var w = stanObejrzane();
            if (!w.dostepny || !w.stan.gry[gra]) { return true; }
            var zmiana = false;
            Object.keys(w.stan.gry[gra]).forEach(function (okno) { if (w.stan.gry[gra][okno].liczby[n]) { delete w.stan.gry[gra][okno].liczby[n]; zmiana = true; } });
            return zmiana ? zapisKlucza(KLUCZ_OBEJRZANE, w.stan) : true;
        },
        usunGre: function (gra) {
            var w = stanObejrzane();
            if (!w.dostepny || !w.stan.gry[gra]) { return true; }
            delete w.stan.gry[gra];
            return zapisKlucza(KLUCZ_OBEJRZANE, w.stan);
        },
        wyczysc: function () { return usunKlucz(KLUCZ_OBEJRZANE); }
    };

    var Magazyn = {
        klucz: KLUCZ,
        limit: LIMIT,
        wczytaj: wczytaj,
        lista: function (gra) { return (wczytaj().stan.gry[gra] || []).slice(); },
        obserwowana: function (gra, n) { return (wczytaj().stan.gry[gra] || []).indexOf(n) >= 0; },
        dodaj: function (gra, n) {
            if (!poprawna(gra, n)) { return { ok: false, powod: 'liczba' }; }
            var r = zmien(function (s) {
                var l = s.gry[gra] || [];
                if (l.indexOf(n) >= 0) { return { ok: false, powod: 'juz' }; }
                if (l.length >= LIMIT) { return { ok: false, powod: 'limit' }; }
                l.push(n); l.sort(function (a, b) { return a - b; }); s.gry[gra] = l;
                return null;
            });
            if (r.ok) { oglos('lista', gra); }
            return r;
        },
        usun: function (gra, n) {
            if (!poprawna(gra, n)) { return { ok: false, powod: 'liczba' }; }
            var r = zmien(function (s) {
                var l = (s.gry[gra] || []).filter(function (x) { return x !== n; });
                if (l.length) { s.gry[gra] = l; } else { delete s.gry[gra]; }
                return null;
            });
            if (r.ok) { Obejrzane.usunLiczbe(gra, n); oglos('lista', gra); }
            return r;
        },
        okno: function () { return wczytaj().stan.okno; },
        ustawOkno: function (okno) {
            if (!poprawneOkno(okno)) { return { ok: false, powod: 'okno' }; }
            return zmien(function (s) { s.okno = okno; return null; });
        },
        /** Import (Fala 3): cala lista naraz po pelnej walidacji; odrzucenie = bez zapisu. */
        zastap: function (gry, okno) {
            if (!gry || typeof gry !== 'object' || Array.isArray(gry)) { return { ok: false, powod: 'format' }; }
            var s = pusty(), klucze = Object.keys(gry);
            if (okno !== undefined && okno !== null) { if (!poprawneOkno(okno)) { return { ok: false, powod: 'format' }; } s.okno = String(okno); }
            for (var i = 0; i < klucze.length; i++) {
                var gra = klucze[i], l = gry[gra];
                if (!Object.prototype.hasOwnProperty.call(PULE, gra) || !Array.isArray(l) || l.length > LIMIT) { return { ok: false, powod: 'format' }; }
                var out = [];
                for (var j = 0; j < l.length; j++) { if (!poprawna(gra, l[j]) || out.indexOf(l[j]) >= 0) { return { ok: false, powod: 'format' }; } out.push(l[j]); }
                out.sort(function (a, b) { return a - b; });
                if (out.length) { s.gry[gra] = out; }
            }
            var w = wczytaj();
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            if (!zapisz(s)) { return { ok: false, powod: 'zapis' }; }
            Obejrzane.wyczysc();                                   // punkty „obejrzano" powstana przy rzeczywistym obejrzeniu
            oglos('lista', null);
            return { ok: true };
        },
        /** Czyszczenie obserwacji (tylko ten klucz i punkty odniesienia). */
        wyczyscWszystko: function () {
            var w = wczytaj();
            if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
            if (!usunKlucz(KLUCZ)) { return { ok: false, powod: 'zapis' }; }
            Obejrzane.wyczysc();
            oglos('lista', null);
            return { ok: true };
        },
        pule: function () { var o = {}; Object.keys(PULE).forEach(function (k) { o[k] = PULE[k]; }); return o; },
        okna: OKNA.slice(),
        ZDARZENIE: ZDARZENIE,
        preferencje: Preferencje,
        obejrzane: Obejrzane
    };
    root.PewniakiObserwowane = Magazyn;

    function tekstBledu(r, n) {
        if (r.powod === 'juz') { return t('already', { n: n }); }
        if (r.powod === 'limit') { return t('limit', { max: LIMIT }); }
        if (r.powod === 'pamiec') { return t('storage_off'); }
        return t('save_failed');
    }

    /* -------------------------------------------------- przycisk na profilu --- */
    function profil(box) {
        var gra = box.getAttribute('data-gra');
        var n = parseInt(box.getAttribute('data-liczba'), 10);
        if (!poprawna(gra, n)) { return; }
        var btn = box.querySelector('[data-obs-przelacz]');
        var link = box.querySelector('[data-obs-link]');
        var status = box.querySelector('[data-obs-profil-status]');
        if (!btn) { return; }

        function odswiez() {
            var w = wczytaj();
            var lista = w.stan.gry[gra] || [];
            var jest = lista.indexOf(n) >= 0;
            btn.setAttribute('aria-pressed', jest ? 'true' : 'false');
            btn.textContent = jest ? t('watching') : t('watch');
            btn.setAttribute('aria-label', jest ? t('watching_aria', { n: n }) : t('watch_aria', { n: n }));
            if (link) { link.textContent = t('panel_link', { k: lista.length }); }
            if (!w.dostepny) { status.textContent = t('storage_off'); }
            else if (w.uszkodzony) { status.textContent = t('storage_bad'); }
        }
        btn.addEventListener('click', function () {
            var jest = btn.getAttribute('aria-pressed') === 'true';
            var r = jest ? Magazyn.usun(gra, n) : Magazyn.dodaj(gra, n);
            status.textContent = r.ok ? (jest ? t('removed', { n: n }) : t('added', { n: n })) : tekstBledu(r, n);
            odswiez();
        });
        root.addEventListener('storage', function (e) { if (e.key === KLUCZ || e.key === null) { odswiez(); } });
        box.hidden = false;
        odswiez();
    }

    /* ------------------------------------------------------------- panel --- */
    function panel(box) {
        var gra = box.getAttribute('data-gra');
        var pula = parseInt(box.getAttribute('data-pula'), 10);
        if (!Object.prototype.hasOwnProperty.call(PULE, gra) || PULE[gra] !== pula) { return; }
        var adresDanych = box.getAttribute('data-dane');
        var adresDziennika = box.getAttribute('data-dziennik') || '';
        // resolveUrl() zdejmuje koncowy ukosnik — /lotto/liczba + /7.
        var profilBaza = (box.getAttribute('data-profil-baza') || '').replace(/\/?$/, '/');
        var q = function (s) { return box.querySelector(s); };
        var ster = q('[data-obs-sterowanie]'), wybor = q('[data-obs-wybor]'), dodajBtn = q('[data-obs-dodaj]');
        var licznik = q('[data-obs-licznik]'), komunikat = q('[data-obs-komunikat]'), pustoEl = q('[data-obs-pusto]');
        var zakresEl = q('[data-obs-zakres]'), bladEl = q('[data-obs-blad]'), bladTekst = q('[data-obs-blad-tekst]');
        var ponow = q('[data-obs-ponow]'), ramka = q('[data-obs-tabela-ramka]'), tabela = q('[data-obs-tabela]');
        var podpis = q('[data-obs-podpis]'), kolTrafienia = q('[data-obs-kol-trafienia]'), wiersze = q('[data-obs-wiersze]');
        var radia = Array.prototype.slice.call(box.querySelectorAll('[data-obs-okno]'));
        var oknoWlasne = q('[data-obs-okno-wlasne]'), oknoZastosuj = q('[data-obs-okno-zastosuj]');
        // Fala 3: preferencje miar, porownanie z poprzednim obejrzeniem.
        var miaryBox = q('[data-obs-miary]'), miaryStatus = q('[data-obs-miary-status]');
        var porownanieEl = q('[data-obs-porownanie]'), naglowek = tabela.tHead && tabela.tHead.rows[0];
        var kolLiczba = q('[data-obs-kol-liczba]');
        // Zarzadzanie lokalna lista nie zalezy od dostepnosci statystyk.
        var listaAwaryjna = doc.createElement('div');
        listaAwaryjna.className = 'przyciski-rzad';
        listaAwaryjna.setAttribute('data-obs-lista', '');
        listaAwaryjna.setAttribute('role', 'group');
        listaAwaryjna.setAttribute('aria-label', t('title'));
        listaAwaryjna.hidden = true;
        komunikat.parentNode.insertBefore(listaAwaryjna, komunikat.nextSibling);

        var otwarte = {};       // liczba -> rozwiniety wiersz (tylko w tym widoku)
        var dane = null;        // zwalidowany pakiet gry
        var pobieranie = null;  // Promise jednego pobrania
        var dziennik = null;    // zwalidowany dziennik ostatnich losowan (Fala 3)
        var dziennikStan = null; // 'ok' | 'blad' | null (jeszcze nie pobierany)
        var pobieranieDziennika = null;
        var numerRenderu = 0;   // spozniona odpowiedz nie nadpisuje nowszego widoku
        var porownania = {};    // okno -> porownanie policzone RAZ w tej wizycie (stabilne przy sortowaniu/preferencjach)
        var zapisaneObejrzenia = {}; // okno -> sygnatura zapisanego punktu (bez powtorzen zapisu)
        var widoczna = false;   // tabela w obszarze widocznym (IntersectionObserver)
        var miary = Preferencje.wczytaj(gra).miary;

        // Zakres: z adresu (?okno=, link z profilu), potem zapamietany, potem 50.
        var okno = Magazyn.okno();
        var zAdresu = null;
        try { zAdresu = new URLSearchParams(root.location.search).get('okno'); } catch (e) { zAdresu = null; }
        if (zAdresu && poprawneOkno(zAdresu)) { okno = zAdresu; }
        radia.forEach(function (r) { r.checked = r.value === okno; });
        if (oknoWlasne) { oknoWlasne.value = OKNA.indexOf(okno) < 0 ? okno : ''; }

        function waliduj(d) {
            function calk(n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n; }
            function czas(s) { return typeof s === 'string' && s.length > 0 && isFinite(Date.parse(s)); }
            var typuje = { lotto: 6, 'lotto-plus': 6, 'mini-lotto': 5, 'multi-multi': 20, eurojackpot: 5, kaskada: 12 }[gra];
            if (!d || d.format !== 'pewniaki-obserwowane-liczby' || d.wersja !== 1 || d.gra !== gra || d.pula !== pula || d.typuje !== typuje || d.pula_rodzaj !== 'glowna' || !czas(d.policzono) || !d.okna) { return false; }
            var k = d.koniec;
            if (k !== null && (!k || !czas(k.drawn_at) || !calk(k.losowan) || k.losowan < 1 || (k.draw_system_id !== null && (!calk(k.draw_system_id) || k.draw_system_id < 0)))) { return false; }
            if (!OKNA_PAKIET.every(function (w) { return !!d.okna[w]; })) { return false; }
            return Object.keys(d.okna).filter(poprawneOkno).every(function (w) {
                var o = d.okna[w];
                if (!o || !('powod' in o)) { return false; }
                if (o.powod !== null) {
                    return (o.powod === 'brak_losowan' || o.powod === 'za_krotka_historia') && o.N === null && o.od === null && o['do'] === null && Array.isArray(o.liczby) && o.liczby.length === 0
                        && (o.powod === 'brak_losowan' ? k === null : k !== null && k.losowan < Number(w));
                }
                if (!k || o.N !== Number(w) || k.losowan < o.N || !czas(o.od) || o['do'] !== k.drawn_at || Date.parse(o.od) > Date.parse(o['do']) || !Array.isArray(o.liczby) || o.liczby.length !== pula) { return false; }
                var suma = 0;
                var poprawne = o.liczby.every(function (x, i) {
                    if (!x || x.n !== i + 1 || !calk(x.h) || x.h < 0 || x.h > o.N || !Array.isArray(x.p) || x.p.length > 3 || !calk(x.pr) || x.pr < 0) { return false; }
                    if (x.h === 0) {
                        if (x.g !== null || x.l !== null || x.p.length || x.pr !== 0) { return false; }
                    } else if (!calk(x.g) || x.g < 0 || x.g >= o.N || !czas(x.l) || Date.parse(x.l) < Date.parse(o.od) || Date.parse(x.l) > Date.parse(o['do']) || (x.g === 0) !== (x.l === o['do'])) { return false; }
                    var partnerzy = [];
                    if (!x.p.every(function (p) {
                        if (!Array.isArray(p) || p.length !== 2 || !calk(p[0]) || p[0] < 1 || p[0] > pula || p[0] === x.n || partnerzy.indexOf(p[0]) >= 0 || !calk(p[1]) || p[1] < 1 || p[1] > x.h) { return false; }
                        partnerzy.push(p[0]); return true;
                    })) { return false; }
                    suma += x.h; return true;
                });
                return poprawne && suma === o.N * typuje;
            });
        }
        /** Dziennik (Fala 3): zamkniety format, id calkowite/null bez powtorzen, czas niemalejacy,
            liczby glowne w puli, odcisk 16 hex, koniec = ostatni wpis. */
        function walidujDziennik(d) {
            function calk(n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n; }
            var typuje = { lotto: 6, 'lotto-plus': 6, 'mini-lotto': 5, 'multi-multi': 20, eurojackpot: 5, kaskada: 12 }[gra];
            if (!d || d.format !== 'pewniaki-obserwowane-dziennik' || d.wersja !== 1 || d.gra !== gra || d.pula !== pula || d.typuje !== typuje || d.pula_rodzaj !== 'glowna' || !calk(d.limit) || d.limit < 1 || !calk(d.losowan_razem) || d.losowan_razem < 0 || !Array.isArray(d.losowania) || d.losowania.length > d.limit || d.losowania.length > 100000) { return false; }
            if (d.losowania.length !== Math.min(d.limit, d.losowan_razem)) { return false; }
            var idy = {}, czas = -Infinity;
            for (var i = 0; i < d.losowania.length; i++) {
                var w = d.losowania[i];
                if (!w || typeof w !== 'object' || !('id' in w) || (w.id !== null && (!calk(w.id) || w.id < 0 || idy[w.id])) || typeof w.t !== 'string' || !isFinite(Date.parse(w.t)) || Date.parse(w.t) < czas || !Array.isArray(w.l) || w.l.length !== typuje || typeof w.o !== 'string' || !/^[0-9a-f]{16}$/.test(w.o)) { return false; }
                var poprz = 0;
                for (var j = 0; j < w.l.length; j++) { if (!calk(w.l[j]) || w.l[j] < 1 || w.l[j] > pula || w.l[j] <= poprz) { return false; } poprz = w.l[j]; }
                if (w.id !== null) { idy[w.id] = true; }
                czas = Date.parse(w.t);
            }
            var k = d.koniec;
            if (!d.losowania.length) { return k === null; }
            var ost = d.losowania[d.losowania.length - 1];
            return !!k && typeof k === 'object' && k.draw_system_id === ost.id && k.drawn_at === ost.t && k.odcisk === ost.o;
        }

        function pobierz() {
            if (dane) { return Promise.resolve(dane); }
            if (pobieranie) { return pobieranie; }
            pobieranie = root.fetch(adresDanych, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) { throw new Error(jst("fragment.05529e9fe8b9a8ea") + r.status); }
                    return r.json();
                })
                .then(function (d) {
                    if (!waliduj(d)) { throw new Error('dane'); }
                    dane = d;
                    return d;
                })
                .catch(function (e) { pobieranie = null; throw e; });
            return pobieranie;
        }
        /** Dziennik ladowany dopiero przy porownywaniu; blad nie psuje tabeli (stan 'blad'). */
        function pobierzDziennik() {
            if (dziennikStan !== null) { return Promise.resolve(dziennik); }
            if (pobieranieDziennika) { return pobieranieDziennika; }
            if (!adresDziennika) { dziennikStan = 'blad'; return Promise.resolve(null); }
            pobieranieDziennika = root.fetch(adresDziennika, { credentials: 'same-origin' })
                .then(function (r) { if (!r.ok) { throw new Error(jst("fragment.05529e9fe8b9a8ea") + r.status); } return r.json(); })
                .then(function (d) { if (!walidujDziennik(d)) { throw new Error('dziennik'); } dziennik = d; dziennikStan = 'ok'; return d; })
                .catch(function () { dziennik = null; dziennikStan = 'blad'; pobieranieDziennika = null; return null; });
            return pobieranieDziennika;
        }

        /** Liczy dowolne okno 7..500 z lekkiego dziennika losowan. */
        function oknoZDziennika(oknoP) {
            var N = Number(oknoP);
            if (!dziennik || dziennikStan !== 'ok' || !poprawneOkno(oknoP)) {
                return { powod: 'brak_dziennika', N: null, od: null, 'do': null, liczby: [] };
            }
            if (!dane.koniec || !dziennik.koniec || dane.koniec.drawn_at !== dziennik.koniec.drawn_at
                || dane.koniec.draw_system_id !== dziennik.koniec.draw_system_id) {
                return { powod: 'niespojny_dziennik', N: null, od: null, 'do': null, liczby: [] };
            }
            if (dziennik.losowania.length < N) {
                return { powod: 'za_krotki_dziennik', N: null, od: null, 'do': null, liczby: [] };
            }
            var proba = dziennik.losowania.slice(-N), h = [], ostatni = [], razem = [];
            for (var n = 1; n <= pula; n++) { h[n] = 0; ostatni[n] = -1; razem[n] = {}; }
            proba.forEach(function (los, i) {
                los.l.forEach(function (n) {
                    h[n]++; ostatni[n] = i;
                    los.l.forEach(function (m) { if (m !== n) { razem[n][m] = (razem[n][m] || 0) + 1; } });
                });
            });
            var liczby = [];
            for (var x = 1; x <= pula; x++) {
                var partnerzy = Object.keys(razem[x]).map(function (m) { return [Number(m), razem[x][m]]; });
                partnerzy.sort(function (a, b) { return b[1] - a[1] || a[0] - b[0]; });
                var top = partnerzy.slice(0, 3), remis = 0;
                if (top.length === 3) {
                    var prog = top[2][1];
                    partnerzy.slice(3).forEach(function (p) { if (p[1] === prog) { remis++; } });
                }
                liczby.push({ n: x, h: h[x], g: h[x] ? N - 1 - ostatni[x] : null,
                    l: h[x] ? proba[ostatni[x]].t : null, p: top, pr: remis });
            }
            return { powod: null, N: N, od: proba[0].t, 'do': proba[N - 1].t, liczby: liczby };
        }

        function zapewnijOkno() {
            if (!dane.okna[okno]) { dane.okna[okno] = oknoZDziennika(okno); }
            return dane.okna[okno];
        }

        function el(tag, klasa, tekst) {
            var x = doc.createElement(tag);
            if (klasa) { x.className = klasa; }
            if (tekst !== undefined && tekst !== null) { x.textContent = tekst; }
            return x;
        }
        function kula(n, mala) {
            var k = el('span', 'kula' + (mala ? ' kula--mala' : '') + ' kula--' + gra, String(n));
            k.setAttribute('aria-hidden', 'true');
            return k;
        }
        function profilUrl(n) { return profilBaza + n + '?okno=' + encodeURIComponent(okno); }

        function sterowanie(lista, stanPamieci) {
            licznik.textContent = t('count', { n: lista.length, max: LIMIT });
            Array.prototype.forEach.call(wybor.options, function (o) {
                o.disabled = lista.indexOf(parseInt(o.value, 10)) >= 0;
            });
            if (wybor.options[wybor.selectedIndex] && wybor.options[wybor.selectedIndex].disabled) {
                var wolna = Array.prototype.filter.call(wybor.options, function (o) { return !o.disabled; })[0];
                if (wolna) { wybor.value = wolna.value; }
            }
            dodajBtn.disabled = lista.length >= LIMIT || !stanPamieci.dostepny;
        }

        /* ---------------------------------------------- preferencje miar --- */
        function kolumny() { return miary.filter(function (m) { return m !== 'p'; }); }
        function ustawMiary() {
            if (!miaryBox) { return; }
            var wierszeM = {};
            Array.prototype.forEach.call(miaryBox.querySelectorAll('[data-obs-miara]'), function (w) { wierszeM[w.getAttribute('data-obs-miara')] = w; });
            var kolejnosc = miary.concat(MIARY.filter(function (m) { return miary.indexOf(m) < 0; }));
            kolejnosc.forEach(function (m, i) {
                var w = wierszeM[m];
                if (!w) { return; }
                miaryBox.appendChild(w);                                  // przeniesienie = kolejnosc
                var wl = w.querySelector('[data-obs-miara-wlacz]');
                if (wl) { wl.checked = miary.indexOf(m) >= 0; }
                var gora = w.querySelector('[data-obs-miara-gora]'), dol = w.querySelector('[data-obs-miara-dol]');
                var aktywna = miary.indexOf(m) >= 0, poz = miary.indexOf(m);
                if (gora) { gora.disabled = !aktywna || poz === 0; }
                if (dol) { dol.disabled = !aktywna || poz === miary.length - 1; }
                w.setAttribute('data-obs-pozycja', String(i + 1));
            });
            var brak = miaryBox.querySelector('[data-obs-miary-brak]');
            if (brak) { brak.hidden = miary.length > 0; }
        }
        function zapiszMiary(nowe, fokus) {
            var r = Preferencje.zapisz(gra, nowe);
            if (!r.ok) {
                // Bez udawania sukcesu: widok wraca do zapisanych preferencji.
                miary = Preferencje.wczytaj(gra).miary;
                if (miaryStatus) { miaryStatus.textContent = r.powod === 'pamiec' ? t('storage_off') : t('prefs_save_failed'); }
            } else {
                miary = r.miary;
                if (miaryStatus) { miaryStatus.textContent = ''; }
            }
            ustawMiary();
            if (dane && !ramka.hidden) { pokazTabele(Magazyn.lista(gra)); }
            if (fokus) { fokus(); }
        }
        if (miaryBox) {
            miaryBox.addEventListener('change', function (e) {
                var wl = e.target && e.target.hasAttribute && e.target.hasAttribute('data-obs-miara-wlacz') ? e.target : null;
                if (!wl) { return; }
                var m = wl.getAttribute('data-obs-miara-wlacz');
                var nowe = miary.filter(function (x) { return x !== m; });
                if (wl.checked) {
                    // wlaczona miara wraca na swoje miejsce w kolejnosci wierszy (jak stoi w fieldset)
                    var kolejnoscDom = Array.prototype.map.call(miaryBox.querySelectorAll('[data-obs-miara]'), function (w) { return w.getAttribute('data-obs-miara'); });
                    nowe = kolejnoscDom.filter(function (x) { return x === m || miary.indexOf(x) >= 0; });
                }
                zapiszMiary(nowe, function () { var x = miaryBox.querySelector('[data-obs-miara-wlacz="' + m + '"]'); if (x) { x.focus(); } });
            });
            miaryBox.addEventListener('click', function (e) {
                var b = e.target.closest ? e.target.closest('button') : null;
                if (!b || !miaryBox.contains(b)) { return; }
                var gora = b.getAttribute('data-obs-miara-gora'), dol = b.getAttribute('data-obs-miara-dol');
                var m = gora || dol; if (!m) { return; }
                var i = miary.indexOf(m); if (i < 0) { return; }
                var j = gora ? i - 1 : i + 1; if (j < 0 || j >= miary.length) { return; }
                var nowe = miary.slice(); nowe[i] = miary[j]; nowe[j] = m;
                zapiszMiary(nowe, function () {
                    var x = miaryBox.querySelector('[data-obs-miara-' + (gora ? 'gora' : 'dol') + '="' + m + '"]');
                    if (x && !x.disabled) { x.focus(); } else { var y = miaryBox.querySelector('[data-obs-miara-' + (gora ? 'dol' : 'gora') + '="' + m + '"]'); if (y) { y.focus(); } }
                });
            });
        }

        /* ------------------------------------ porownanie z obejrzeniem --- */
        function przerwaTxt(g) { return g === null ? t('cmp_gap_none') : liczbaTxt(g); }
        /** Porownanie policzone RAZ dla zakresu w tej wizycie (patrz naglowek pliku). */
        function policzPorownanie(oknoP, lista) {
            var o = dane.okna[oknoP];
            if (o.powod !== null) { return { stan: 'brak', wiersze: {} }; }
            var k = dane.koniec;
            if (dziennikStan !== 'ok' || !dziennik) { return { stan: 'brak_dziennika', wiersze: {} }; }
            if (dziennik.koniec === null || dziennik.koniec.drawn_at !== k.drawn_at || dziennik.koniec.draw_system_id !== k.draw_system_id) { return { stan: 'niespojne', wiersze: {} }; }
            var teraz = { id: k.draw_system_id, t: k.drawn_at, o: dziennik.koniec.odcisk };
            if (teraz.id === null) { return { stan: 'brak_id', wiersze: {}, teraz: teraz }; }
            var punkt = Obejrzane.wczytaj(gra, oknoP);
            var wynik = { stan: 'pierwsza', teraz: teraz, wiersze: {}, N: o.N, okno: oknoP };
            if (!punkt) { return wynik; }
            if (punkt.id === null) { wynik.stan = 'brak_id'; return wynik; }
            var idx = -1;
            for (var i = 0; i < dziennik.losowania.length; i++) { if (dziennik.losowania[i].id === punkt.id) { idx = i; break; } }
            wynik.od = punkt; wynik.odId = punkt.id; wynik.doId = teraz.id; wynik.odData = punkt.t; wynik.doData = teraz.t;
            if (idx < 0) {
                if (Date.parse(dziennik.koniec.drawn_at) < Date.parse(punkt.t)) { wynik.stan = 'cofniety'; }
                else if (dziennik.losowania.length && Date.parse(dziennik.losowania[0].t) > Date.parse(punkt.t)) { wynik.stan = 'poza'; wynik.limit = dziennik.limit; }
                else { wynik.stan = 'korekta'; }
                return wynik;
            }
            var wpis = dziennik.losowania[idx];
            if (wpis.o !== punkt.o || wpis.t !== punkt.t) { wynik.stan = 'korekta'; return wynik; }
            var nowe = dziennik.losowania.slice(idx + 1);
            wynik.k = nowe.length;
            wynik.stan = nowe.length ? 'ok' : 'bez_nowych';
            wynik.pozaOknem = nowe.length > o.N;
            lista.forEach(function (n) {
                var b = punkt.liczby[n];
                if (!b) { wynik.wiersze[n] = { stan: 'nowa' }; return; }
                var ileNowych = 0;
                for (var j = 0; j < nowe.length; j++) { if (nowe[j].l.indexOf(n) >= 0) { ileNowych++; } }
                var w = o.liczby[n - 1];
                var wypadly = b.h + ileNowych - w.h;
                wynik.wiersze[n] = wypadly < 0 ? { stan: 'niespojne' } : { stan: 'ok', nowe: ileNowych, wypadly: wypadly, hPrzed: b.h, hPo: w.h, gPrzed: b.g, gPo: w.g };
            });
            return wynik;
        }
        function porownanie(lista) {
            if (!porownania[okno]) { porownania[okno] = policzPorownanie(okno, lista); }
            var p = porownania[okno];
            // liczby dodane w trakcie wizyty: nowa obserwacja (bez dziedziczenia)
            if (p.stan === 'ok' || p.stan === 'bez_nowych') { lista.forEach(function (n) { if (!p.wiersze[n]) { p.wiersze[n] = { stan: 'nowa' }; } }); }
            return p;
        }
        function tekstPorownania(p) {
            switch (p.stan) {
                case 'pierwsza': return t('cmp_first', { nr: p.teraz.id, data: data(p.teraz.t) });
                case 'bez_nowych': return t('cmp_none', { nr: p.doId, data: data(p.doData) });
                case 'ok': return t('cmp_new' + odmiana(p.k), { k: liczbaTxt(p.k), od: p.odId, 'do': p.doId, data: data(p.odData) }) + (p.pozaOknem ? ' ' + t('cmp_beyond_window', { okno: p.okno }) : '');
                case 'korekta': return t('cmp_corrected', { nr: p.odId });
                case 'cofniety': return t('cmp_rewound', { nr: p.odId });
                case 'poza': return t('cmp_beyond', { limit: liczbaTxt(p.limit) });
                case 'brak_id': return t('cmp_no_id');
                case 'niespojne': return t('cmp_mismatch');
                case 'brak_dziennika': return t('cmp_no_journal');
                default: return '';
            }
        }
        function stanDoZapisu(p) { return p && (p.stan === 'pierwsza' || p.stan === 'ok' || p.stan === 'bez_nowych' || p.stan === 'korekta' || p.stan === 'cofniety' || p.stan === 'poza'); }
        /** „Obejrzano": tylko po udanym renderze, w widocznej karcie, gdy tabela jest na ekranie. */
        function zapiszObejrzenie() {
            var p = porownania[okno];
            if (!p || !stanDoZapisu(p) || ramka.hidden || !widoczna || doc.visibilityState !== 'visible' || !dane) { return; }
            var lista = Magazyn.lista(gra), o = dane.okna[okno];
            if (!lista.length || o.powod !== null) { return; }
            var sig = p.teraz.id + '|' + p.teraz.o + '|' + lista.join(',');
            if (zapisaneObejrzenia[okno] === sig) { return; }
            var liczby = {};
            lista.forEach(function (n) { var w = o.liczby[n - 1]; liczby[n] = { h: w.h, g: w.g }; });
            var r = Obejrzane.zapisz(gra, okno, { id: p.teraz.id, t: p.teraz.t, o: p.teraz.o, liczby: liczby });
            if (r.ok) { zapisaneObejrzenia[okno] = sig; if (porownanieEl && porownanieEl.getAttribute('data-obs-porownanie-stan') === p.stan) { porownanieEl.removeAttribute('data-obs-zapis-bledny'); } }
            else if (porownanieEl) { porownanieEl.setAttribute('data-obs-zapis-bledny', '1'); porownanieEl.textContent = tekstPorownania(p) + ' ' + t('seen_save_failed'); }
        }
        if (typeof root.IntersectionObserver === 'function') {
            new root.IntersectionObserver(function (wpisy) {
                widoczna = wpisy.some(function (w) { return w.isIntersecting; });
                if (widoczna) { zapiszObejrzenie(); }
            }, { threshold: 0.15 }).observe(ramka);
        } else {
            widoczna = true;                                          // stary silnik: brak pomiaru, liczy sie widocznosc karty
        }
        doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible') { zapiszObejrzenie(); } });

        function naglowekTabeli(o) {
            if (!naglowek) { return; }
            Array.prototype.slice.call(naglowek.querySelectorAll('[data-obs-kol]')).forEach(function (th) { naglowek.removeChild(th); });
            kolumny().forEach(function (m) {
                var th = el('th');
                th.setAttribute('scope', 'col');
                th.setAttribute('data-obs-kol', m);
                if (m === 'h') { th.setAttribute('data-obs-kol-trafienia', ''); th.textContent = t('col_hits', { N: liczbaTxt(o.N) }); }
                else if (m === 'g') { th.textContent = t('col_gap'); }
                else { th.className = 'obserwowane__kol-data'; th.textContent = t('col_last'); }
                naglowek.appendChild(th);
            });
        }

        function wierszLiczby(w, o, p) {
            var n = w.n;
            var tr = el('tr');
            tr.setAttribute('data-obs-liczba', String(n));
            // Przelacznikiem szczegolow jest sama liczba (kula + strzalka): cel 44 px,
            // a tabela ma najwyzej 4 kolumny — od 5 main.js zamienia ja na telefonie w karty
            // z etykietami (adapt()) i wiersz rozwiniecia nie zostalby pod liczba.
            var idSz = 'obserwowane-szczegoly-' + n;
            var th = el('th');
            th.setAttribute('scope', 'row');
            var btn = el('button', 'obserwowane__liczba');
            btn.type = 'button';
            btn.setAttribute('aria-controls', idSz);
            btn.setAttribute('aria-expanded', otwarte[n] ? 'true' : 'false');
            btn.setAttribute('aria-label', t('details_aria', { n: n }));
            btn.setAttribute('data-obs-rozwin', String(n));
            btn.appendChild(kula(n, false));
            var strz = el('span', 'obserwowane__strzalka', '▾');
            strz.setAttribute('aria-hidden', 'true');
            btn.appendChild(strz);
            th.appendChild(btn);
            tr.appendChild(th);
            var pw = p && p.wiersze ? p.wiersze[n] : null;
            var zmiana = pw && pw.stan === 'ok' && (p.stan === 'ok') ? pw : null;
            kolumny().forEach(function (m) {
                if (m === 'h') {
                    var tdH = el('td', 'liczbowa');
                    tdH.appendChild(doc.createTextNode(liczbaTxt(w.h)));
                    tdH.setAttribute('data-obs-trafienia', String(w.h));
                    if (zmiana && (zmiana.nowe || zmiana.wypadly)) {
                        var b = el('span', 'obserwowane__zmiana', t('cmp_badge', { nowe: liczbaTxt(zmiana.nowe), wypadly: liczbaTxt(zmiana.wypadly) }));
                        b.setAttribute('data-obs-zmiana', zmiana.nowe + ':' + zmiana.wypadly);
                        tdH.appendChild(b);
                    }
                    tr.appendChild(tdH);
                } else if (m === 'g') {
                    var gap = w.g === null ? t('never') : (w.g === 0 ? t('gap_zero') : t('gap_draws' + odmiana(w.g), { g: liczbaTxt(w.g) }));
                    var tdG = el('td', null, gap);
                    tdG.setAttribute('data-obs-przerwa', w.g === null ? 'brak' : String(w.g));
                    tr.appendChild(tdG);
                } else {
                    var tdL = el('td', 'obserwowane__kol-data', w.l === null ? t('never') : data(w.l));
                    tr.appendChild(tdL);
                }
            });

            var trS = el('tr');
            trS.id = idSz;
            trS.hidden = !otwarte[n];
            trS.setAttribute('data-obs-szczegoly', String(n));
            var td = el('td');
            td.colSpan = 1 + kolumny().length;
            var box2 = el('div', 'obserwowane__szczegoly');
            if (miary.indexOf('l') >= 0) {
                var pOst = el('p', "tekst-maly obserwowane__ostatnie");
                pOst.appendChild(el('strong', null, t('col_last') + ': '));
                pOst.appendChild(doc.createTextNode(w.l === null ? t('never') : data(w.l)));
                box2.appendChild(pOst);
            }
            if (miary.indexOf('p') >= 0) {
                box2.appendChild(el('p', 'tekst-maly', t('partners')));
                if (w.p.length) {
                    var ul = el('ul', 'obserwowane__partnerzy');
                    w.p.forEach(function (pp) {
                        var li = el('li', 'obserwowane__partner');
                        li.setAttribute('data-obs-partner', pp[0] + ':' + pp[1]);
                        li.appendChild(kula(pp[0], true));
                        li.appendChild(el('span', 'sr-only', String(pp[0]) + ': '));
                        li.appendChild(el('span', 'tekst-maly', t('partner_joint' + odmiana(pp[1]), { h: liczbaTxt(pp[1]) })));
                        ul.appendChild(li);
                    });
                    box2.appendChild(ul);
                    if (w.pr > 0) { box2.appendChild(el('p', 'tekst-maly', t('partners_tie', { k: w.pr }))); }
                } else {
                    box2.appendChild(el('p', 'tekst-maly', t('partners_none')));
                }
            }
            // Zmiany od poprzedniego obejrzenia (tylko przy porownywalnym stanie).
            if (pw && (p.stan === 'ok' || p.stan === 'bez_nowych')) {
                var pZ = el('p', "tekst-maly obserwowane__porownanie-wiersz");
                pZ.setAttribute('data-obs-porownanie-wiersz', pw.stan);
                if (pw.stan === 'nowa') { pZ.textContent = t('cmp_row_new'); }
                else if (pw.stan === 'niespojne') { pZ.textContent = t('cmp_mismatch'); }
                else if (p.stan === 'bez_nowych') { pZ.textContent = t('cmp_row_none'); }
                else {
                    pZ.textContent = t('cmp_row', { k: liczbaTxt(p.k), nowe: liczbaTxt(pw.nowe), okno: p.okno, wypadly: liczbaTxt(pw.wypadly), hPrzed: liczbaTxt(pw.hPrzed), hPo: liczbaTxt(pw.hPo), gPrzed: przerwaTxt(pw.gPrzed), gPo: przerwaTxt(pw.gPo) });
                    pZ.setAttribute('data-obs-zmiana-wiersz', pw.nowe + ':' + pw.wypadly + ':' + pw.hPrzed + ':' + pw.hPo);
                }
                box2.appendChild(pZ);
            }
            var akcje = el('div', 'przyciski-rzad');
            var a = el('a', 'link-akcja', t('profile_link', { n: n }));
            a.href = profilUrl(n);
            a.setAttribute('data-obs-profil-link', String(n));
            akcje.appendChild(a);
            var usun = el('button', "przycisk przycisk--drugi", t('remove'));
            usun.type = 'button';
            usun.setAttribute('aria-label', t('remove_aria', { n: n }));
            usun.setAttribute('data-obs-usun', String(n));
            akcje.appendChild(usun);
            box2.appendChild(akcje);
            td.appendChild(box2);
            trS.appendChild(td);
            return [tr, trS];
        }

        function pokazTabele(lista) {
            var o = zapewnijOkno();
            bladEl.hidden = true;
            while (wiersze.firstChild) { wiersze.removeChild(wiersze.firstChild); }
            if (o.powod !== null) {
                ramka.hidden = true;
                zakresEl.hidden = false;
                var ile = dziennik && dziennik.losowania ? dziennik.losowania.length : (dane.koniec ? dane.koniec.losowan : 0);
                zakresEl.textContent = o.powod === 'za_krotki_dziennik'
                    ? t('journal_short', { ile: liczbaTxt(ile), okno: okno })
                    : (ile > 0 ? t('short', { ile: liczbaTxt(ile), okno: okno }) : t('no_draws'));
                zakresEl.setAttribute('data-obs-stan', 'za-krotko');
                if (porownanieEl) { porownanieEl.hidden = true; }
                return;
            }
            listaAwaryjna.hidden = true;
            while (listaAwaryjna.firstChild) { listaAwaryjna.removeChild(listaAwaryjna.firstChild); }
            zakresEl.hidden = false;
            zakresEl.removeAttribute('data-obs-stan');
            var koniec = dane.koniec;
            zakresEl.textContent = t('range_info', { okno: okno, N: liczbaTxt(o.N), od: data(o.od), 'do': data(o['do']) }) + ' '
                + (koniec && koniec.draw_system_id !== null && koniec.draw_system_id !== undefined
                    ? t('data_info_id', { nr: koniec.draw_system_id, data: data(koniec.drawn_at) })
                    : t('data_info', { data: data(koniec ? koniec.drawn_at : o['do']) }));
            podpis.textContent = t('caption', { okno: okno });
            naglowekTabeli(o);
            tabela.setAttribute('data-obs-okno-tabeli', okno);
            tabela.setAttribute('data-obs-kolumny', kolumny().join(','));
            var p = porownanie(lista);
            if (porownanieEl) {
                porownanieEl.hidden = p.stan === 'brak';
                porownanieEl.setAttribute('data-obs-porownanie-stan', p.stan);
                if (p.k !== undefined) { porownanieEl.setAttribute('data-obs-nowych', String(p.k)); } else { porownanieEl.removeAttribute('data-obs-nowych'); }
                porownanieEl.removeAttribute('data-obs-zapis-bledny');
                porownanieEl.textContent = tekstPorownania(p);
            }
            lista.forEach(function (n) {
                var w = o.liczby[n - 1];
                wierszLiczby(w, o, p).forEach(function (r) { wiersze.appendChild(r); });
            });
            var spokojny = q('[data-obs-miary-spokojny]');
            if (spokojny) { spokojny.hidden = miary.length > 0; }
            ramka.hidden = false;
            zapiszObejrzenie();
        }

        function render(fokus) {
            var numer = ++numerRenderu;
            var w = wczytaj();
            var lista = (w.stan.gry[gra] || []).slice();
            sterowanie(lista, w);
            while (listaAwaryjna.firstChild) { listaAwaryjna.removeChild(listaAwaryjna.firstChild); }
            listaAwaryjna.hidden = !lista.length || !!(dane && dane.okna[okno] && dane.okna[okno].powod === null);
            if (!listaAwaryjna.hidden) {
                lista.forEach(function (n) {
                    var b = el('button', "przycisk przycisk--drugi", t('remove_aria', { n: n }));
                    b.type = 'button'; b.setAttribute('data-obs-usun', String(n));
                    listaAwaryjna.appendChild(b);
                });
            }
            if (!w.dostepny) { komunikat.textContent = t('storage_off'); }
            else if (w.uszkodzony && !komunikat.textContent) { komunikat.textContent = t('storage_bad'); }

            if (!lista.length) {
                pustoEl.hidden = false; ramka.hidden = true; zakresEl.hidden = true; bladEl.hidden = true;
                if (porownanieEl) { porownanieEl.hidden = true; }
                while (wiersze.firstChild) { wiersze.removeChild(wiersze.firstChild); }
                if (fokus) { fokus(); }
                return;
            }
            pustoEl.hidden = true;
            if (!dane) {
                // Stare liczby nie moga zostac pod etykieta nowego zakresu.
                ramka.hidden = true;
                zakresEl.hidden = false;
                zakresEl.textContent = t('loading');
                zakresEl.setAttribute('data-obs-stan', 'ladowanie');
            }
            // Dziennik idzie rownolegle z pakietem; jego brak nie blokuje tabeli.
            Promise.all([pobierz(), pobierzDziennik()]).then(function () {
                if (numer !== numerRenderu) { return; }
                zapewnijOkno();
                pokazTabele(lista);
                if (fokus) { fokus(); }
            }, function () {
                if (numer !== numerRenderu) { return; }
                ramka.hidden = true;
                zakresEl.hidden = true;
                if (porownanieEl) { porownanieEl.hidden = true; }
                while (wiersze.firstChild) { wiersze.removeChild(wiersze.firstChild); }
                bladTekst.textContent = t('error');
                bladEl.hidden = false;
            });
        }

        dodajBtn.addEventListener('click', function () {
            var n = parseInt(wybor.value, 10);
            var r = Magazyn.dodaj(gra, n);
            komunikat.textContent = r.ok ? t('added', { n: n }) : tekstBledu(r, n);
            render(function () {
                var b = box.querySelector('[data-obs-rozwin="' + n + '"]');
                if (r.ok && b) { b.focus(); }
            });
        });
        radia.forEach(function (r) {
            r.addEventListener('change', function () {
                if (!r.checked) { return; }
                okno = r.value;
                if (oknoWlasne) { oknoWlasne.value = ''; }
                var zapis = Magazyn.ustawOkno(okno);
                if (!zapis.ok) { komunikat.textContent = tekstBledu(zapis); }
                render();
            });
        });
        if (oknoZastosuj && oknoWlasne) {
            oknoZastosuj.addEventListener('click', function () {
                var nowe = String(oknoWlasne.value || '').trim();
                if (!poprawneOkno(nowe)) {
                    komunikat.textContent = t('range_invalid');
                    oknoWlasne.focus();
                    return;
                }
                okno = String(Number(nowe));
                radia.forEach(function (r) { r.checked = false; });
                var zapis = Magazyn.ustawOkno(okno);
                komunikat.textContent = zapis.ok ? '' : tekstBledu(zapis);
                render();
            });
        }
        ponow.addEventListener('click', function () { render(); });
        box.addEventListener('click', function (e) {
            var cel = e.target.closest ? e.target.closest('button') : null;
            if (!cel) { return; }
            if (cel.hasAttribute('data-obs-rozwin')) {
                var n = parseInt(cel.getAttribute('data-obs-rozwin'), 10);
                otwarte[n] = cel.getAttribute('aria-expanded') !== 'true';
                cel.setAttribute('aria-expanded', otwarte[n] ? 'true' : 'false');
                var sz = box.querySelector('[data-obs-szczegoly="' + n + '"]');
                if (sz) { sz.hidden = !otwarte[n]; }
                return;
            }
            if (cel.hasAttribute('data-obs-usun')) {
                var m = parseInt(cel.getAttribute('data-obs-usun'), 10);
                var przed = Magazyn.lista(gra);
                var r = Magazyn.usun(gra, m);
                komunikat.textContent = r.ok ? t('removed', { n: m }) : tekstBledu(r, m);
                if (r.ok) {
                    delete otwarte[m];
                    // usunieta liczba nie wraca z odziedziczonym porownaniem
                    Object.keys(porownania).forEach(function (k) { if (porownania[k].wiersze) { delete porownania[k].wiersze[m]; } });
                }
                var nast = przed.filter(function (x) { return x > m; })[0] || przed.filter(function (x) { return x < m; }).pop();
                render(function () {
                    var b = nast ? box.querySelector(listaAwaryjna.hidden ? '[data-obs-rozwin="' + nast + '"]' : '[data-obs-lista] [data-obs-usun="' + nast + '"]') : null;
                    (b || wybor).focus();
                });
            }
        });
        root.addEventListener('storage', function (e) {
            if (e.key === KLUCZ || e.key === null) { render(); }
            if (e.key === KLUCZ_PREF || e.key === null) { miary = Preferencje.wczytaj(gra).miary; ustawMiary(); if (dane && !ramka.hidden) { pokazTabele(Magazyn.lista(gra)); } }
        });
        doc.addEventListener(ZDARZENIE, function (e) {
            // zmiany z tej samej strony (kopia/import/reset) — bez ponownego pobierania danych
            var d = e && e.detail ? e.detail : {};
            if (d.rodzaj === 'preferencje') { miary = Preferencje.wczytaj(gra).miary; ustawMiary(); if (dane && !ramka.hidden) { pokazTabele(Magazyn.lista(gra)); } }
            if (d.rodzaj === 'lista' && d.gra === null) {
                // import/czyszczenie: zakres tez mogl sie zmienic; porownania liczymy od nowa
                okno = Magazyn.okno();
                radia.forEach(function (r) { r.checked = r.value === okno; });
                if (oknoWlasne) { oknoWlasne.value = OKNA.indexOf(okno) < 0 ? okno : ''; }
                porownania = {}; zapisaneObejrzenia = {}; render();
            }
        });

        ustawMiary();
        ster.hidden = false;
        render();
    }

    Array.prototype.forEach.call(doc.querySelectorAll('[data-obs-profil]'), profil);
    Array.prototype.forEach.call(doc.querySelectorAll('[data-obs-panel]'), panel);
})(window, document);
